import { Integration } from 'store/slices/integrations/list/types';

export const getPath = (integration: Integration) => {
  let path;
  if (integration.key === 'kandji') {
    if (integration.copy === 'Request Access') {
      path = integration.requestAccessPath;
    }
  } else if (integration.key === 'jamf') {
    if (integration.copy === 'Request Access') {
      path = integration.requestAccessPath;
    } else if (integration.copy === 'Manage' && integration.detailsPath) {
      path = integration.detailsPath;
    } else if (integration.copy === 'Manage') {
      path = integration.settingsPath;
    } else if (integration.copy === 'Connect') {
      path = integration.connectPath;
    }
  } else if (integration.copy === 'Manage') {
    path = integration.settingsPath;
  } else if (integration.copy === 'Connect') {
    path = integration.connectPath;
  }
  return path;
};
